import { Automation } from "./automation";
import { Blogs } from "./blogs";
import { CentralBanks } from "./central-banks";
import { ClearingInstitutions } from "./clearing-institutions";
import { ContactUs } from "./contact-us";
import { Ecosystem } from "./ecosystem";
import { EndUserApps } from "./end-user-apps";
import { Home } from "./home";
import { Insights } from "./insights";
import { Investor } from "./investor";
import { JoinOurTeam } from "./join-our-team";
import { LeadGen } from "./lead-gen";
import { Leadership } from "./leadership";
import { Legal } from "./legal";
import { News } from "./news";
import { OriginatingInstitutions } from "./originating-institutions";
import { PayallLife } from "./payall-life";
import { PayallStory } from "./payall-story";
import { PaymentChannels } from "./payment-channels";
import { PaymentNetworks } from "./payment-networks";
import { PaymentOrchestration } from "./payment-orchestration";
import { Platform } from "./platform";
import { Posts } from "./posts";
import { Resources } from "./resources";
import { Solutions } from "./solutions";
import { UniversalPaymentAccount } from "./universal-payment-account";
import { P2pMoneyAbroad } from "./p2p-money-abroad";
import { Search } from "./search";
import { Error } from "./error";

export const PageComponents = {
  Automation,
  Blogs,
  CentralBanks,
  ClearingInstitutions,
  ContactUs,
  Ecosystem,
  EndUserApps,
  Home,
  Insights,
  Investor,
  JoinOurTeam,
  LeadGen,
  Leadership,
  Legal,
  News,
  OriginatingInstitutions,
  PayallLife,
  PayallStory,
  PaymentChannels,
  PaymentNetworks,
  PaymentOrchestration,
  Platform,
  Posts,
  Resources,
  Solutions,
  UniversalPaymentAccount,
  P2pMoneyAbroad,
  Search,
  Error,
};

export type PageComponentKeys = keyof typeof PageComponents;
